require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-five-technologies-changing-k-12-education.json") })
        }
      }, "path---blog-five-technologies-changing-k-12-education");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-five-technologies-changing-k-12-education!./.cache/json/blog-five-technologies-changing-k-12-education.json
// module id = 818
// module chunks = 231608221292675